import Auth from '@/store/mutations/auth'

export default {
  ...Auth
}
